<template>
  <div class="outpage">
<!--    <div @click="dianl = !dianl" style="position: fixed;top: 50%;right: 10%;color: white;">8888</div>-->
    <div class="w100 sta1 flex-cc">
      <div class="flex-cc">
        <img class="mlogo1" src="../assets/logo.png" alt="">
        <div class="mlogo2">
          <div class="mlp1">网络空间内生安全知识平台</div>
          <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
        </div>
      </div>
      <div class="sta3">智能助理</div>
<!--      <div class="sta3">{{ statusMessage }}</div>-->
    </div>
    <div class="w100 stamiddle">
      <div class="stam1">
        <div class="flex-hl w100" v-if="dianl">
          <div class="w30 lineleft">
            <img v-if="!sayloading" src="../assets/img/ai2.gif" class="lineimg1" alt="">
            <img v-if="sayloading && isPaused" src="../assets/img/ai2.gif" class="lineimg1" alt="">
            <img v-if="sayloading && !isPaused" src="../assets/img/ai2.gif" class="lineimg1" alt="">
            <!-- <img v-if="sayloading && isPaused" src="../assets/img/aiqi.png" class="lineimg1" alt="">
            <img v-if="sayloading && !isPaused" src="../assets/img/new1.gif" class="lineimg1" alt=""> -->

            <!--            <img v-if="!sayloading" src="../assets/img/hep.png" class="lineimg1" alt="">-->
<!--            <img v-if="sayloading" src="../assets/img/heg.gif" class="lineimg1" alt="">-->
<!--            <video-->
<!--                v-if="sayloading"-->
<!--                ref="videoRef"-->
<!--                class="linevideo1"-->
<!--                autoplay-->
<!--                muted-->
<!--                loop-->
<!--            >-->
<!--              <source src="../assets/img/newai.mp4" type="video/mp4">-->
<!--              <source src="../assets/img/new1.mp4" type="video/mp4">-->

<!--            </video>-->
          </div>
          <div class="ai-m w70 mt20" ref="scrollContainer">
            <div v-for="(item,index) in infolist" :key="index">
              <div class="amm1 flex-hr flex-box" v-if="item.my == 1">
                <div class='flex-1'>
                  <div class="amm2">{{ userinfo.nickname }}</div>
                  <div class="amm3">{{ item.content }}</div>
                </div>
                <img class="amm4" :src="userinfo.photo?userinfo.photo:require('../assets/img/morentouxiang.png')"
                     alt="">
              </div>
              <div class="amm12 flex-hl flex-box" v-if="item.my == 2">
                <img class="amm7" src="../assets/img/aitou2.png" alt="">
                <div class='flex-1'>
                  <div class="amm6">智能助理</div>
<!--                  <el-input-->
<!--                      type="textarea"-->
<!--                      autosize-->
<!--                      :disabled="true"-->
<!--                      resize="none"-->
<!--                      class="amm5"-->
<!--                      placeholder=""-->
<!--                      v-model="item.content">-->
<!--                  </el-input>-->
                  <div
                    class="amm5"
                    :class="{ 'amm5-tts-playing': ttsPlayingMsgIndex === index && isPlaying }"
                  >
                    <template v-if="shouldShowTtsParts(index)">
                      <span
                        v-for="(part, pi) in getTtsDisplayParts(item.content, index)"
                        :key="'tts-part-' + index + '-' + pi"
                        :class="{ 'tts-highlight': part.highlight }"
                        :ref="part.refKey"
                      >{{ part.text }}</span>
                    </template>
                    <template v-else>{{ item.content }}</template>
                    <span
                      v-if="item.content === '思考中...' && nosend && index === infolist.length - 1"
                      class="think-elapsed"
                    >{{ thinkingSeconds }}s</span>
                    <img
                      v-if="item.content && item.content !== '思考中...'"
                      src="../assets/img/copy.png"
                      class="copytxt"
                      @click="copynow(item.content)"
                      alt=""
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newa-list mt20" v-if="!dianl">
              <div class="flex-sc w100 mbom10">
                <img class="ai-tou" src="../assets/img/aitou2.png" alt="">
                <div class="ai-tou1">你好，我是智能助理，有什么问题可以直接问我</div>
              </div>
          <div class="w100 flex-cc">
            <div class="ai-tou2" @click="filltxt('什么是编码信道的数学模型，如何进行分析？')">什么是编码信道的数学模型，如何进行分析？</div>
            <div class="ai-tou2" @click="filltxt('拟态构造设备如何试点应用，其发展前景如何？')">拟态构造设备如何试点应用，其发展前景如何？</div>
            <div class="ai-tou2" @click="filltxt('如何进行原理验证与测试评估？')">如何进行原理验证与测试评估？</div>
            <div class="ai-tou2" @click="filltxt('如何对拟态构造防御原理进行验证？')">如何对拟态构造防御原理进行验证？</div>
          </div>
          <div class="w100 flex-cc">
            <div class="ai-tou2" @click="filltxt('拟态防御在工程上是如何实现的？')">拟态防御在工程上是如何实现的？</div>
            <div class="ai-tou2" @click="filltxt('什么是网络安全的拟态防御？')">什么是网络安全的拟态防御？</div>
            <div class="ai-tou2" @click="filltxt('拟态防御的原始含义和长远愿景是什么？')">拟态防御的原始含义和长远愿景是什么？</div>
            <div class="ai-tou2" @click="filltxt('什么是动态异构冗余架构？')">什么是动态异构冗余架构？</div>
          </div>
          <div class="w100 flex-cc">
            <div class="ai-tou2" @click="filltxt('基础防御要素有哪些，它们的作用是什么？')">基础防御要素有哪些，它们的作用是什么？</div>
            <div class="ai-tou2" @click="filltxt('内生安全与可靠性技术包含哪些内容？')">内生安全与可靠性技术包含哪些内容？</div>
            <div class="ai-tou2" @click="filltxt('防御理念与技术有哪些新的进展？')">防御理念与技术有哪些新的进展？</div>
            <div class="ai-tou2" @click="filltxt('如何概述经典防御技术？')">如何概述经典防御技术？</div>
            <div class="ai-tou2" @click="filltxt('如何对网络攻击进行形式化描述？')">如何对网络攻击进行形式化描述？</div>
          </div>
          <div class="w100 flex-cc">
            <div class="ai-tou2" @click="filltxt('基于漏洞和后门的内生安全问题具体有哪些？')">基于漏洞和后门的内生安全问题具体有哪些？</div>
          </div>
        </div>
        <div class="flex-hl w100 mbom5 mt5">
          <div class="yuyinb flex-cc mr10" @click="startlu">
            <img v-if="!isRecording" src="../assets/img/maike.png" alt="">
            <img v-if="isRecording" src="../assets/img/bo.gif" alt="">
            <span>语音录制</span>
          </div>
          <el-upload
              class="avatar-uploader"
              :action="sttUploadAction"
              :headers="sttUploadHeaders"
              name="file"
              :show-file-list="false"
              :on-error="handleerror"
              accept=".wav"
              :on-success="handleAvatarSuccess">
            <div class="yuyinb flex-cc mr10">
              <img style="width: 20px; height: 20px; cursor: pointer;"
                   src="../assets/img/yinpin.png" class="avatar">
              <span>上传音频</span>
            </div>
          </el-upload>
          <div class="yuyinb flex-cc mr10" @click="bosure">
            <img v-if="yuyinsure" src="../assets/img/yuyin.png" alt="">
            <img v-if="!yuyinsure" src="../assets/img/quxiaoyuyin.png" alt="">
            <span>语音播报</span>
          </div>
          <div v-if="yuyinsure && isPlaying" class="yuyinb flex-cc" @click="togglePause">
            <img v-if="!isPaused" src="../assets/img/bofang.png" alt="">
            <img v-if="isPaused" src="../assets/img/zanting.png" alt="">
            <span>{{ !isPaused?'暂停播放':'开始播放' }}</span>
          </div>
        </div>
        <div class="difa mbom20">
          <el-input
              type="textarea"
              autosize
              @keyup.enter.native="tosend"
              resize="none"
              class="difain"
              placeholder="输入内容并发送"
              v-model="content">
          </el-input>
<!--          <div class="difaimg2 flex-hls">-->
<!--            <el-upload-->
<!--                class="avatar-uploader"-->
<!--                action="https://47.100.122.218/api/stt/recognize-speech"-->
<!--                :show-file-list="false"-->
<!--                :on-error="handleerror"-->
<!--                accept=".wav"-->
<!--                :on-success="handleAvatarSuccess">-->
<!--              <img style="width: 30px; height: 35px; cursor: pointer; object-fit: contain;"-->
<!--                   src="../assets/img/sfujian.png" class="avatar">-->
<!--            </el-upload>-->
<!--            <div class="difaimg3"></div>-->
<!--          </div>-->
          <div class="difaimg1" @click="tosend">
            <img src="../assets/img/upjian.png" alt="">
          </div>
        </div>
      </div>
      <div class="bottomd flex-cc">
        <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
        <span class="shus"></span>
        <img src="../assets/guohui.png" class="jinghui" alt="">
        <span>苏CP备14016373号-4</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import request from '@/utils/request'
import { getLoginStorage } from '@/utils/auth'
import Audiopage from "@/views/audio.vue";
import { streamBailianApplication, abortBailianStream } from '@/utils/dashscopeApplicationChat'
export default {
  name: 'statistics',
  components: {Audiopage},
  computed: {
    sttUploadAction() {
      return process.env.NODE_ENV === 'development'
        ? '/api/aiutil/wavToText'
        : 'https://www.esks.com.cn/multimodal/api/aiutil/wavToText'
    },
    sttUploadHeaders() {
      const userData = getLoginStorage()
      if (userData && userData.token) {
        return { Authorization: `Bearer ${userData.token}` }
      }
      return {}
    },
  },
  data() {
    return {
      utterThis: null,
      status: '等待朗读',
      content: '',
      isRecording: false,
      audioContext: null,
      mediaStream: null,
      scriptProcessor: null,
      recordedBuffers: [],
      audioBlob: null,
      uploading: false,
      loading: false,
      nosend: false,//是否禁止发送
      sayloading: false,
      yuyinsure: false,
      userinfo: JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null,
      // infolist: [{my:1,content:'111'},{my:2,content:'\'编码信道的数学模型是用来描述信息在传输过程中经过编码、调制、传输介质、解调等环节后，\', \'输入和输出之间关系的数学表达式。\', \'这种模型对于通信系统的设计和性能分析至关重要。\', \'下面详细介绍编码信道的数学模型及其分析方法。\', \'\\n\\n### 编码信道的数学模型\\n\\n1. **离散无记忆信道（DMC）**：\\n   - **定义**：离散无记忆信道是指输入和输出都是离散符号，\', \'且当前输出只依赖于当前输入，\', \'与过去的输入和输出无关。\', \'\\n   - **数学表示**：\\n     - 输入符号集：\\\\( X = \\\\{x_1, x_2, \\\\l…2, \\\\ldots, y_n\\\\} \\\\)\\n     - 信道转移概率矩阵：\\\\( P(Y|X) \\\\)，\', \'其中 \\\\( P(y_j|x_i) \\\\) 表示在输入 \\\\( x_i \\\\) 时输出 \\\\( y_j \\\\) 的概率。\', \'\\n\\n2. **连续信道**：\\n   - **定义**：连续信道的输入和输出是连续的随机变量。\', \'\\n   - **数学表示**：\\n     - 输入随机变量：\\\\( X \\\\)\\n     - 输出随机变…## 分析方法\\n\\n1. **信道容量**：\\n   - **定义**：信道容量是指在给定信道条件下，\', \'信道能够达到的最大信息传输速率。\', \'\\n   - **计算方法**：\\n     - 对于离散无记忆信道，\', \'[检测到敏感内容，已屏蔽]\', \'定义为：\\n       \\\\[\\n       I(X; Y) = H(Y) - H(Y|X)\\n       \\\\]\\n       \\\\( H(Y) \\\\) 是输出熵，\', \'\\\\( H(Y|X) \\\\) 是条件熵。\', \'\\n     - 对于连续信道，\', \'信道容量可以通过类似的方法计算，\', \'但需要用到连续随机变量的熵和互信息。\', \'\\n\\n2. **误码率分析**：\\n   - **定义**：误码率是指接收端错误判决的概率。\', \'\\n   - **计算方法**：\\n     - 对于离散信道，\', \'可以通过信道转移概率矩阵计算误码率。例如，\', \'对于二进制对称信道（BSC），\', \'误码率为 \\\\( p \\\\)。\\n     - 对于连续信道，\', \'可以通过积分计算误码率。例如，\', \'在高斯信道中，\', \'误码率可以通过高斯分布的累积分布函数（CDF）计算。\', \'\\n\\n3. **互信息分析**：\\n   - **定义**：互信息 \\\\( I(X; Y) \\\\) 衡量了输入和输出之间的信息传递量。\', \'\\n   - **计算方法**：\\n     - 对于离散信道，\', \'互信息可以直接通过定义计算。\\n     - 对于连续信道，\', \'互信息需要通过积分计算。\', \'\\n\\n4. **信道建模与仿真**：\\n   - **方法**：通过计算机仿真模拟信道的输入和输出关系，\', \'验证理论分析的正确性。\', \'\\n   - **工具**：常用的仿真工具包括MATLAB、Python等。\', \'\\n\\n### 具体步骤\\n\\n1. **确定信道模型**：根据实际通信系统的特点，\', \'选择合适的信道模型（如DMC、高斯信道等）。\', \'\\n2. **建立数学表达式**：根据信道特性，\', \'建立输入和输出之间的数学关系（如转移概率矩阵、概率密度函数等）。\', \'\\n3. **计算性能指标**：利用香农公式、误码率公式等计算信道容量、误码率等关键性能指标。\', \'\\n4. **仿真验证**：通过计算机仿真验证理论分析的结果，\', \'确保模型的准确性。\', \'\\n\\n### 示例\\n\\n假设一个简单的二进制对称信道（BSC），\', \'输入符号集为 \\\\( \\\\{0, 1\\\\} \\\\)，\', \'输出符号集也为 \\\\( \\\\{0, 1\\\\} \\\\)，\', \'误传概率为 \\\\( p \\\\)。\', \'[检测到敏感内容，已屏蔽]\', \'可以对编码信道进行系统的数学建模和性能分析，\', \'为通信系统的设计和优化提供理论依据。\''},],
      infolist:[],
      dianl:false,//点击了上面或者下面的发送-隐藏初始页面
      alltext:[],//全部的文字信息
      // 音频URL数组（实际项目中可能是ID或其他标识）
      audioUrls: [],
      currentIndex: -1,
      isPlaying: false,//原始的判断-开始播放
      isPaused: false,//后来加的暂停和开始-要是开始播放的状态才会出现
      statusMessage: '点击开始播放',
      progress: 0,
      currentAudio: null,
      loadingStates: {}, // 记录每个音频的加载状态
      audioStatus: {}, // 记录每个音频的播放状态
      thinkingSeconds: 0,
      thinkingTimerId: null,
      ttsSegments: [],
      ttsPlayingMsgIndex: -1,
      ttsCurrentSegment: -1,
      ttsAbortController: null,
      ttsObjectUrls: [],
      ttsSessionId: 0,
      ttsStreamActive: false,
      ttsStreamDone: false,
      ttsStreamProcessedLength: 0,
      ttsSynthQueue: [],
      ttsSynthDraining: false,
      ttsWaitingForSegment: false,
      ttsLeaveCancelled: false,
    }
  },
  mounted() {
    this.scrollToBottom();
  },
  methods: {
    stripChatMarkdown(text) {
      if (!text) return ''
      return String(text)
        .replace(/\*/g, '')
        .replace(/#/g, '')
        .replace(/\\|_/g, '')
    },
    startThinkingTimer() {
      this.stopThinkingTimer()
      this.thinkingSeconds = 0
      this.thinkingTimerId = setInterval(() => {
        this.thinkingSeconds++
      }, 1000)
    },
    stopThinkingTimer() {
      if (this.thinkingTimerId) {
        clearInterval(this.thinkingTimerId)
        this.thinkingTimerId = null
      }
      this.thinkingSeconds = 0
    },
    copynow(val){
      navigator.clipboard
          .writeText(val)
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch((err) => {
            // 复制失败
            console.error("复制失败");
          });
    },
    /** 从 wavToText 响应中提取文本并填入输入框 */
    applySttText(res) {
      const payload = res && res.data != null ? res.data : res;
      let text = payload && payload.text;
      if (!text && payload && payload.rawResult) {
        try {
          const raw = JSON.parse(payload.rawResult);
          const sentences = raw.Sentences || [];
          text = sentences.map(s => s.Text || '').join('');
        } catch (err) {
          console.warn('[STT] rawResult 解析失败', err);
        }
      }
      text = text != null ? String(text).trim() : '';
      if (!text) return false;
      this.content = text;
      this.dianl = true;
      return true;
    },
    async startRecording() {
      try {
        this.isRecording = true;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.mediaStream = stream;

        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new AudioCtx();
        const source = this.audioContext.createMediaStreamSource(stream);

        // 使用实际采样率（更准确）
        const SAMPLE_RATE = this.audioContext.sampleRate <= 48000 ? this.audioContext.sampleRate : 48000;
        const BUFFER_SIZE = 4096;

        this.scriptProcessor = this.audioContext.createScriptProcessor(BUFFER_SIZE, 1, 1);
        this.recordedBuffers = [];

        this.scriptProcessor.onaudioprocess = (e) => {
          const input = e.inputBuffer.getChannelData(0); // Float32Array [-1, 1]
          const int16 = new Int16Array(input.length);
          for (let i = 0; i < input.length; i++) {
            // 防止溢出
            const s = Math.max(-1, Math.min(1, input[i]));
            int16[i] = s < 0 ? s * 32768 : s * 32767;
          }
          this.recordedBuffers.push(int16);
        };

        source.connect(this.scriptProcessor);
        this.scriptProcessor.connect(this.audioContext.destination);
      } catch (err) {
        this.isRecording = false;
        alert('麦克风错误：' + err);
      }
    },

    stopRecording() {
      if (!this.isRecording) return;

      const actualSampleRate = this.audioContext.sampleRate <= 48000
        ? this.audioContext.sampleRate : 48000;

      this.scriptProcessor.disconnect();
      this.mediaStream.getTracks().forEach(t => t.stop());
      this.audioContext.close();

      // 合并所有 Int16Array
      let totalLen = 0;
      this.recordedBuffers.forEach(buf => totalLen += buf.length);
      const fullBuffer = new Int16Array(totalLen);
      let offset = 0;
      this.recordedBuffers.forEach(buf => {
        fullBuffer.set(buf, offset);
        offset += buf.length;
      });

      const downsampled = this.downsampleTo16k(fullBuffer, actualSampleRate);
      this.audioBlob = this.createWavBlob(downsampled.buffer, downsampled.rate);
      this.isRecording = false;
      this.$nextTick(() => {
        this.uploadAudio();
      })
    },

    async uploadAudio() {
      if (!this.audioBlob) {
        this.$message.warning('无录音数据，请重新录制');
        return;
      }
      if (this.uploading) return;
      this.uploading = true;
      const loading = this.$message({
        message: '正在识别语音...',
        duration: 0,
        offset: 200
      });
      const fd = new FormData();
      fd.append('file', this.audioBlob, 'recording.wav');
      try {
        const res = await request.post('/aiutil/wavToText', fd);
        if (this.applySttText(res)) {
          this.$message.success('语音识别成功');
          this.reset();
        } else {
          this.$message.error(res.message || '未识别到文字');
        }
      } catch (e) {
        console.error('[STT] wavToText 失败:', e);
        const msg = (e && e.message) ? e.message : '识别失败，请重试';
        this.$message.error(msg);
      } finally {
        loading.close();
        this.uploading = false;
      }
    },

    reset() {
      this.audioBlob = null;
    },
    /** 降采样到 16kHz，匹配阿里云录音文件识别常用模型 */
    downsampleTo16k(int16Array, fromRate) {
      const targetRate = 16000;
      if (!fromRate || fromRate <= targetRate) {
        return { buffer: int16Array, rate: fromRate || targetRate };
      }
      const ratio = fromRate / targetRate;
      const newLen = Math.max(1, Math.floor(int16Array.length / ratio));
      const out = new Int16Array(newLen);
      for (let i = 0; i < newLen; i++) {
        out[i] = int16Array[Math.min(int16Array.length - 1, Math.floor(i * ratio))];
      }
      return { buffer: out, rate: targetRate };
    },

    createWavBlob(pcmInt16Array, sampleRate = 16000) {
      const channels = 1;
      const bitDepth = 16;
      const bytesPerSample = bitDepth / 8;
      const blockAlign = channels * bytesPerSample;
      const byteRate = sampleRate * blockAlign;

      const dataLength = pcmInt16Array.length * bytesPerSample;
      const wavHeaderSize = 44;
      const totalLength = wavHeaderSize + dataLength;

      const buffer = new ArrayBuffer(totalLength);
      const view = new DataView(buffer);

      // RIFF
      this.writeString(view, 0, 'RIFF');
      view.setUint32(4, totalLength - 8, true);
      this.writeString(view, 8, 'WAVE');

      // fmt
      this.writeString(view, 12, 'fmt ');
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, channels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, byteRate, true);
      view.setUint16(32, blockAlign, true);
      view.setUint16(34, bitDepth, true);

      // data
      this.writeString(view, 36, 'data');
      view.setUint32(40, dataLength, true);

      // PCM
      let offset = wavHeaderSize;
      for (let i = 0; i < pcmInt16Array.length; i++) {
        view.setInt16(offset, pcmInt16Array[i], true);
        offset += 2;
      }

      return new Blob([buffer], {type: 'audio/wav'});
    },

    writeString(view, offset, str) {
      for (let i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
      }
    },
    // 随机数
    randomnum() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < 2; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    startlu() {
      if (this.uploading) return;
      if (!this.isRecording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },
    gettext(val) {
      if (val && val.data) {
        this.applySttText(val);
      }
    },
    filltxt(txt){
      this.content = txt;
    },
    bosure(){
      const enabling = !this.yuyinsure;
      this.yuyinsure = !this.yuyinsure;
      if (!this.yuyinsure) {
        this.stopAudio();
        return;
      }
      if (!enabling || this.ttsLeaveCancelled) {
        return;
      }
      const assistantIdx = this.infolist.length - 1;
      const item = assistantIdx >= 0 ? this.infolist[assistantIdx] : null;
      if (!item || item.my !== 2 || !this.nosend) {
        return;
      }
      this.ttsStreamDone = false;
      const shown = this.stripChatMarkdown(item.content);
      if (shown && shown !== '思考中...') {
        this.initStreamingTts(assistantIdx);
        this.handleStreamingTts(shown, assistantIdx);
      } else {
        this.initStreamingTts(assistantIdx);
      }
    },
    handleerror(res) {
      this.$message({
        message: '读取失败，请检查文件或和联系管理人员！',
        type: 'error'
      });
    },
    handleAvatarSuccess(res) {
      if (this.applySttText(res)) {
        this.$message.success('语音识别成功');
      } else {
        this.$message.error(res.message || '未识别到文字');
      }
    },
    tosend() {
      // let da='在数学模型中，,信道通常表示为一个概率转移函数，,该函数定义了从发送信号到接收信号的概率分布。,';
      // if(da.indexOf('。,')>-1){
      //   da = da.replace(/。,/g,'。');
      // }
      // if(da.indexOf('，,')>-1){
      //   da = da.replace(/，,/g,',');
      // }
      // console.log('da',da)
      // return;
      let audioUrl = '';
      let audio = '';
      let that = this;
      this.dianl = true;
      if(!this.content){
        this.$message({
          message: '请输入问题！',
          type: 'warning'
        });
        return;
      }
      if(this.nosend){
        this.$message({
          message: '思考中请稍后再提问！',
          type: 'warning'
        });
        return;
      }
      this.nosend = true;
      this.infolist.push({my: 1, content: this.content},{my: 2, content:'思考中...'});
      this.startThinkingTimer();
      this.$nextTick(()=>{
        this.scrollToBottom();//这里如果刷新没过来 使用$nexttick
      })
      // console.log('this.infolist', this.infolist)
      // let paystate = setTimeout(()=>{
      //   let idx = this.infolist.findIndex(item => item.content == '思考中...');
      //   if(idx != -1){
      //     this.infolist.splice(idx,1)
      //   }
      //   this.infolist.push({my: 2, content: '思考弯沉222222222222'});
      //   this.nosend = false;//只要返回了，就能继续提问
      //   this.$nextTick(()=>{
      //     this.scrollToBottom();//这里如果刷新没过来 使用$nexttick
      //   })
      // },2000);
      let content1= JSON.parse(JSON.stringify(this.content));
      this.content = '';

      const assistantIdx = this.infolist.length - 1;
      if (this.yuyinsure) {
        this.initStreamingTts(assistantIdx);
      } else {
        this.stopAudio();
      }

      this.$nextTick(() => {
        streamBailianApplication(content1, {
          onDelta: (full) => {
            const shown = this.stripChatMarkdown(full);
            if (shown && shown !== '思考中...') {
              this.stopThinkingTimer();
            }
            this.$set(this.infolist[assistantIdx], 'content', shown || '思考中...');
            if (this.yuyinsure && shown && shown !== '思考中...') {
              this.handleStreamingTts(shown, assistantIdx);
            }
            this.$nextTick(() => {
              if (this.shouldAutoScrollChat()) {
                this.scrollToBottom();
              }
            });
          },
          onDone: (full) => {
            this.stopThinkingTimer();
            const huifu = this.stripChatMarkdown(full);
            this.$set(this.infolist[assistantIdx], 'content', huifu || '（无返回内容）');
            this.alltext = [{ content: huifu }];
            this.audioUrls = [{ content: huifu }];
            this.nosend = false;
            that.content = '';
            if (this.yuyinsure && huifu) {
              this.finishStreamingTts(huifu, assistantIdx);
            }
            this.$nextTick(() => {
              if (this.shouldAutoScrollChat()) {
                this.scrollToBottom();
              }
            });
          },
          onError: (msg) => {
            this.stopThinkingTimer();
            this.ttsStreamActive = false;
            this.ttsStreamDone = true;
            this.$set(
              this.infolist[assistantIdx],
              'content',
              '获取回复失败：' + (msg || '未知错误')
            );
            this.nosend = false;
            this.$message.error('对话请求失败');
            console.error('Bailian stream error:', msg);
            this.$nextTick(() => this.scrollToBottom());
          },
        }).catch((e) => {
          if (e && e.name !== 'AbortError') {
            this.nosend = false;
            console.error(e);
          }
        });
      });
    },
    initStreamingTts(msgIndex) {
      if (this.ttsLeaveCancelled) {
        return;
      }
      if (this.ttsStreamActive && this.ttsPlayingMsgIndex === msgIndex && !this.ttsStreamDone) {
        return;
      }
      this.stopAudio();
      this.ttsAbortController = new AbortController();
      this.ttsStreamActive = true;
      this.ttsStreamDone = false;
      this.ttsStreamProcessedLength = 0;
      this.ttsSynthQueue = [];
      this.ttsSynthDraining = false;
      this.ttsWaitingForSegment = false;
      this.ttsPlayingMsgIndex = msgIndex;
      this.ttsSegments = [];
      this.ttsCurrentSegment = -1;
      this.currentIndex = -1;
      this.isPlaying = false;
      this.sayloading = true;
      this.drainTtsSynthQueue();
    },

    shouldAutoScrollChat() {
      return !this.yuyinsure || !this.isPlaying;
    },

    isSentenceDelimiter(ch) {
      return ch === '。' || ch === '！' || ch === '？' || ch === '；'
        || ch === '.' || ch === '!' || ch === '?' || ch === ';' || ch === '\n';
    },

    isWeakTtsDelimiter(ch) {
      return ch === '，' || ch === ',' || ch === '、' || ch === '：' || ch === ':';
    },

    isTtsDelimiter(ch) {
      return this.isSentenceDelimiter(ch) || this.isWeakTtsDelimiter(ch);
    },

    findLastTtsDelimiterInRange(text, start, endInclusive) {
      for (let k = endInclusive; k >= start; k--) {
        if (this.isTtsDelimiter(text[k])) {
          return k;
        }
      }
      return -1;
    },

    shouldShowTtsParts(msgIndex) {
      return this.ttsPlayingMsgIndex === msgIndex && this.ttsSegments.length > 0;
    },

    getTtsDisplayParts(content, msgIndex) {
      if (!content || !this.shouldShowTtsParts(msgIndex)) {
        return [{ text: content || '', highlight: false, refKey: null }];
      }
      const parts = [];
      let cursor = 0;
      for (let si = 0; si < this.ttsSegments.length; si++) {
        const seg = this.ttsSegments[si];
        let start = typeof seg.start === 'number' ? seg.start : cursor;
        let end = typeof seg.end === 'number' ? seg.end : start + (seg.text || '').length;
        start = Math.max(0, Math.min(start, content.length));
        end = Math.max(start, Math.min(end, content.length));
        // 防止片段区间重叠导致同一段文字渲染两次（TTS 实际只播 trim 后的 seg.text）
        start = Math.max(start, cursor);
        if (start >= end) {
          continue;
        }
        if (cursor < start) {
          parts.push({ text: content.slice(cursor, start), highlight: false, refKey: null });
        }
        const isCurrent = si === this.ttsCurrentSegment && this.isPlaying;
        parts.push({
          text: content.slice(start, end),
          highlight: isCurrent,
          refKey: isCurrent ? 'ttsSeg-' + msgIndex + '-' + si : null,
        });
        cursor = end;
      }
      if (cursor < content.length) {
        parts.push({ text: content.slice(cursor), highlight: false, refKey: null });
      }
      return parts.length
        ? parts
        : [{ text: content, highlight: false, refKey: null }];
    },

    /**
     * 流式 TTS 切分：仅在标点处切分，避免英文单词/中文词语被截断；
     * 流式输出时遇到标点即切一段，尽早开始播报。
     */
    splitForStreamingTts(pending, baseOffset, flushRemainder = false) {
      const chunks = [];
      const ttsMaxChars = 280;
      let consumed = 0;
      let i = 0;
      while (i < pending.length) {
        let cut = -1;
        for (let j = i; j < pending.length; j++) {
          if (this.isTtsDelimiter(pending[j])) {
            cut = j;
            break;
          }
          if (j - i + 1 >= ttsMaxChars) {
            cut = this.findLastTtsDelimiterInRange(pending, i, j);
            if (cut < 0) {
              cut = j;
            }
            break;
          }
        }
        if (cut < 0) {
          if (flushRemainder && i < pending.length) {
            cut = pending.length - 1;
          } else {
            break;
          }
        }
        const raw = pending.slice(i, cut + 1);
        const trimmed = raw.trim();
        if (trimmed) {
          const trimStart = raw.indexOf(trimmed);
          const absStart = baseOffset + i + (trimStart >= 0 ? trimStart : 0);
          chunks.push({
            text: trimmed,
            start: absStart,
            end: absStart + trimmed.length,
          });
        }
        consumed = cut + 1;
        i = cut + 1;
      }
      return { chunks, consumed };
    },

    enqueueTtsJobs(chunks, msgIndex) {
      chunks.forEach((chunk) => {
        this.ttsSynthQueue.push({
          sentence: chunk.text,
          msgIndex,
          start: chunk.start,
          end: chunk.end,
        });
      });
      if (!this.ttsSynthDraining) {
        this.drainTtsSynthQueue();
      }
    },

    handleStreamingTts(fullText, msgIndex) {
      if (!this.yuyinsure || this.ttsLeaveCancelled) {
        return;
      }
      if (!this.ttsStreamActive || this.ttsPlayingMsgIndex !== msgIndex) {
        if (this.ttsStreamDone) {
          return;
        }
        this.initStreamingTts(msgIndex);
      }
      if (!this.ttsStreamActive || this.ttsStreamDone) {
        return;
      }
      const base = this.ttsStreamProcessedLength;
      const pending = fullText.slice(base);
      const { chunks, consumed } = this.splitForStreamingTts(pending, base);
      if (!chunks.length) {
        return;
      }
      this.ttsStreamProcessedLength += consumed;
      this.enqueueTtsJobs(chunks, msgIndex);
    },

    finishStreamingTts(fullText, msgIndex) {
      if (this.ttsLeaveCancelled || !this.yuyinsure) {
        return;
      }
      if (!this.ttsStreamActive) {
        this.initStreamingTts(msgIndex);
      }
      // 先按标点切分已缓冲内容，再 flush 末尾无标点残段，避免整段一次性合成导致首轮需等全文结束才播报
      this.handleStreamingTts(fullText, msgIndex);
      const tailStart = this.ttsStreamProcessedLength;
      const tailRaw = fullText.slice(tailStart);
      const { chunks, consumed } = this.splitForStreamingTts(tailRaw, tailStart, true);
      if (chunks.length) {
        this.ttsStreamProcessedLength = tailStart + consumed;
        this.enqueueTtsJobs(chunks, msgIndex);
      }
      this.ttsStreamActive = false;
      this.ttsStreamDone = true;
      if (!this.ttsSynthDraining) {
        this.drainTtsSynthQueue();
      }
    },

  /**
   * 严格按队列顺序串行合成，避免并行完成导致片段乱序、漏播。
   * 流式输出期间保持等待，有新片段立即合成（边输出边播）。
   */
    async drainTtsSynthQueue() {
      if (this.ttsSynthDraining) {
        return;
      }
      this.ttsSynthDraining = true;
      const sessionId = this.ttsSessionId;

      while (true) {
        if (sessionId !== this.ttsSessionId) {
          break;
        }

        if (this.ttsSynthQueue.length > 0) {
          const job = this.ttsSynthQueue.shift();
          try {
            const seg = await this.synthesizeSingleSegment(job.sentence, sessionId);
            if (seg && sessionId === this.ttsSessionId) {
              seg.text = job.sentence;
              seg.start = job.start;
              seg.end = job.end;
              this.onSegmentSynthesized(seg, job.msgIndex);
            }
          } catch (e) {
            if (e && e.name === 'AbortError') {
              break;
            }
            console.error('TTS synth error:', e);
          }
          continue;
        }

        if (this.ttsStreamDone) {
          break;
        }
        if (this.ttsStreamActive) {
          await new Promise((resolve) => setTimeout(resolve, 60));
          continue;
        }
        break;
      }

      this.ttsSynthDraining = false;
      if (this.ttsStreamDone && !this.ttsSegments.length && this.currentIndex < 0) {
        this.stopAudio();
      }
    },

    async synthesizeSingleSegment(text, sessionId) {
      if (!text || !text.trim() || sessionId !== this.ttsSessionId) {
        return null;
      }
      const res = await request.post('/aiutil/textToSpeech', { text: text.trim() }, {
        responseType: 'blob',
        validateStatus: () => true,
        headers: {
          Accept: 'audio/wav, application/json, */*',
          'Content-Type': 'application/json',
        },
        signal: this.ttsAbortController ? this.ttsAbortController.signal : undefined,
      });
      if (sessionId !== this.ttsSessionId) {
        return null;
      }
      if (!res || res.status !== 200) {
        const errText = await (res.data instanceof Blob ? res.data.text() : Promise.resolve('语音合成失败'));
        throw new Error(errText || '语音合成失败');
      }
      const audioUrl = URL.createObjectURL(res.data);
      this.ttsObjectUrls.push(audioUrl);
      return { text: text.trim(), audioUrl };
    },

    onSegmentSynthesized(seg, msgIndex) {
      this.ttsSegments.push(seg);
      this.ttsPlayingMsgIndex = msgIndex;
      this.isPlaying = true;
      this.sayloading = true;
      if (this.currentIndex < 0) {
        this.playSegment(0);
      } else if (this.ttsWaitingForSegment) {
        this.playSegment(this.currentIndex + 1);
      }
    },

    playSegment(index) {
      if (index >= this.ttsSegments.length) {
        if (this.ttsStreamActive || this.ttsSynthDraining || this.ttsSynthQueue.length) {
          this.ttsWaitingForSegment = true;
          return;
        }
        this.stopAudio();
        this.statusMessage = '所有音频播放完毕';
        return;
      }
      if (!this.isPlaying) {
        return;
      }

      this.ttsWaitingForSegment = false;
      this.currentIndex = index;
      this.ttsCurrentSegment = index;
      this.loadingStates[index] = false;
      this.audioStatus[index] = '播放中...';
      this.statusMessage = `正在播放第 ${index + 1} 段`;

      this.$nextTick(() => {
        this.scrollSegmentToCenter(this.ttsPlayingMsgIndex, index);
      });

      const seg = this.ttsSegments[index];
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.currentAudio = null;
      }
      this.currentAudio = new Audio(seg.audioUrl);

      this.currentAudio.addEventListener('timeupdate', () => {
        if (this.currentAudio && this.currentAudio.duration) {
          this.progress = (this.currentAudio.currentTime / this.currentAudio.duration) * 100;
        }
      });

      this.currentAudio.addEventListener('ended', () => {
        this.audioStatus[index] = '播放完成';
        this.currentAudio = null;
        this.playSegment(index + 1);
      });

      this.currentAudio.addEventListener('error', () => {
        this.audioStatus[index] = '播放失败';
        this.currentAudio = null;
        if (index + 1 < this.ttsSegments.length) {
          this.playSegment(index + 1);
        } else if (this.ttsStreamActive || this.ttsSynthQueue.length || this.ttsSynthDraining) {
          this.ttsWaitingForSegment = true;
        } else {
          this.stopAudio();
        }
      });

      this.currentAudio.play().catch((error) => {
        console.error('播放失败:', error);
        if (!this.ttsStreamActive && !this.ttsSynthQueue.length) {
          this.stopAudio();
        }
      });
    },

    scrollSegmentToCenter(msgIndex, segIndex) {
      const refKey = 'ttsSeg-' + msgIndex + '-' + segIndex;
      const el = this.$refs[refKey];
      const target = Array.isArray(el) ? el[0] : el;
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },

    // 暂停/继续切换
    togglePause() {
      if (!this.currentAudio) return;
      if (this.isPaused) {
        this.resumeAudio();
      } else {
        this.pauseAudio();
      }
    },

    // 暂停音频
    pauseAudio() {
      if (this.currentAudio) {
        this.currentAudio.pause();
        this.isPaused = true;
        this.statusMessage = '播放已暂停';
        if (this.currentIndex >= 0) {
          this.audioStatus[this.currentIndex] = '已暂停';
        }
      }
    },

    // 恢复播放
    resumeAudio() {
      if (this.currentAudio) {
        this.currentAudio.play()
            .then(() => {
              this.isPaused = false;
              this.statusMessage = `继续播放音频 ${this.currentIndex + 1}`;
              if (this.currentIndex >= 0) {
                this.audioStatus[this.currentIndex] = '播放中...';
              }
            })
            .catch(error => {
              console.error('恢复播放失败:', error);
              this.statusMessage = '恢复播放失败';
            });
      }
    },
// 停止
    stopAudio() {
      this.ttsSessionId += 1;
      if (this.ttsAbortController) {
        this.ttsAbortController.abort();
        this.ttsAbortController = null;
      }
      if (this.currentAudio) {
        const audio = this.currentAudio;
        this.currentAudio = null;
        audio.pause();
        audio.currentTime = 0;
        audio.src = '';
        audio.load();
      }
      this.ttsObjectUrls.forEach((url) => URL.revokeObjectURL(url));
      this.ttsObjectUrls = [];
      this.isPlaying = false;
      this.isPaused = false;
      this.currentIndex = -1;
      this.progress = 0;
      this.sayloading = false;
      this.ttsSegments = [];
      this.ttsPlayingMsgIndex = -1;
      this.ttsCurrentSegment = -1;
      this.ttsStreamActive = false;
      this.ttsStreamDone = false;
      this.ttsStreamProcessedLength = 0;
      this.ttsSynthQueue = [];
      this.ttsSynthDraining = false;
      this.ttsWaitingForSegment = false;

      this.audioUrls = [];
      this.loadingStates = {};
      this.audioStatus = {};
    },
    tounicode(str) {
      try {
        return decodeURIComponent(JSON.parse('"' + str.replace(/\"/g, '\\"') + '"'));
      } catch (e) {
        return str;
      }
    },
    scrollToBottom() {
      // 获取目标div的DOM元素
      const container = this.$refs.scrollContainer;
      if (container) {
        // 设置滚动条位置到最底部
        container.scrollTop = container.scrollHeight;
      }
    },
    cleanupAssistantOnLeave() {
      this.ttsLeaveCancelled = true;
      abortBailianStream();
      this.stopThinkingTimer();
      this.stopAudio();
      this.ttsStreamDone = true;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.cleanupAssistantOnLeave();
    next();
  },
  beforeDestroy() {
    this.cleanupAssistantOnLeave();
  }
}
</script>
<style scoped lang="scss">
.copytxt{
  width: 20px;
  height: 20px;
  position: absolute;
  right: -25px;
  bottom: 3px;
  cursor: pointer;
}
.think-elapsed {
  margin-left: 10px;
  font-size: 14px;
  color: #8ec5ff;
  font-weight: normal;
  white-space: nowrap;
}
.amm5-tts-playing {
  box-shadow: inset 0 0 0 1px rgba(100, 180, 255, 0.45);
  border-radius: 4px;
}
.tts-highlight {
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.12), rgba(64, 158, 255, 0.28));
  border-radius: 3px;
  transition: background 0.3s ease;
  padding: 0 2px;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}
  //改个外层名字再用
  .tanpassklu {
    /deep/ {
      .el-textarea.is-disabled .el-textarea__inner{
        color: white !important;
      }
      .el-dialog .el-dialog__header {
        display: none !important;
        padding: 0 !important;
      }
      .el-dialog {
        border-radius: 16px;
      }

      .el-dialog__body {
        padding: 0px;
        background: #0B3E73;
        border-radius: 16px;
        overflow: hidden;
      }

      .el-dialog__header {
        display: none;
      }
    }


  }
.ludiv{
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  height: 40vh;
  position: relative;
  .closelu{
    position: absolute;
    width: 23px;
    height: 23px;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
.outpage {
  height: calc(100vh - 80px);
  overflow: hidden;
}
@media screen and (max-width: 1440px)  {
  .ai-m{
    height: 65vh !important;
  }
  .newa-list{
    height: 65vh !important;
  }
}
.ai-tou{
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.ai-tou1{
  box-sizing: border-box;
  padding: 10px 20px;
  font-size: 16PX;
  background: #00326D;
  border-radius: 5px;
  color: white;

}
.ai-tou2{
  cursor: pointer;
  box-sizing: border-box;
  padding: 8px 12px;
  font-size: 16PX;
  border-radius: 5px;
  color: white;
  background: #054589;
  border: 1px solid #1E7ECF;
  margin-right: 5px;
  margin-top: 15px;
}
.yuyinb{
  cursor: pointer;
  width: 115PX;
  height: 37px;
  line-height: 37px;
  box-sizing: border-box;
  border-radius: 4px;
  background: #054589;
  border: 1px solid #1E7ECF;
  img{
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  color: white;
}
.stam1{
  width: 1350px;
}
.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 33px;
}

.mlp2 {
  font-size: 11px;
  letter-spacing: 0 !important;
}

.difa {
  width: 100%;
  height: 17vh;
  //background: cyan;
  overflow-y: auto;
  position: relative;
  .luout{
    z-index: 999;
    position: absolute;
    width: 100%;
    height: 17vh;
    top: 0;
    left: 0;
    background: #0E3E6C;
    border: 1px solid #0090FF;
    border-radius: 16px;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 8px;
    .closelu{
      position: absolute;
      width: 23px;
      height: 23px;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
  }
}

.stamiddle {
  height: calc(100vh - 160px);
  min-height: calc(100vh - 160px);
  overflow-y: auto;
  background-image: url("../assets/img/aiwuq.png") !important;
  &::-webkit-scrollbar {
    display: inline-block;
  }
}

/deep/ {
  .difain .el-textarea__inner {
    width: 100%;
    height: 17vh !important;
    background: #0E3E6C;
    border: 1px solid #0090FF;
    border-radius: 16px;
    font-size: 16px;
    color: white;
    box-sizing: border-box;
    padding: 10px !important;
  }
}
</style>
<!--scoped-->
<style lang="scss">
.difaimg2 {
  width: 50px;
  height: 50px;
  position: absolute;
  bottom: 10px;
  right: 76px;
  //img{
  //  width: 35px;
  //  height: 35px;
  //}
  .difaimg3 {
    width: 1px;
    height: 30px;
    background: #027BD8;
  }
}

.difaimg1 {
  width: 50px;
  height: 50px;
  background: #027BD8;
  border-radius: 10px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  cursor: pointer;
  text-align: center;

  img {
    width: 40px;
    height: 35px;
    margin-top: 7px;
  }
}

.lineleft {
  position: relative;
  //background: cyan;
  .lineimg1 {
    width: 80%;
    height: auto;
    position: absolute;
    bottom: 0;
    border-radius: 10px;
  }
  .linevideo1{
    width: 80%;
    height: auto;
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 10px;

  }
}

.ai-m {
  height: 57vh;
  //background: plum;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 15px;
}
.newa-list {
  width: 100%;
  height: 57vh;
  //background: pink;
  box-sizing: border-box;
  padding-bottom: 15px;
}

.amm1 {
  margin-bottom: 30px;
  box-sizing: border-box;
  padding-left: 80px;
}

.amm12 {
  margin-bottom: 30px;
  box-sizing: border-box;
  padding-right: 80px;
}

.amm3 {
  box-sizing: border-box;
  padding: 10px 15px;
  background: #027BD8;
  border-radius: 7px;
  color: white !important;
  max-width: 100%;
  float: right;
  line-height: 26px;
}

.amm5 {
  box-sizing: border-box;
  padding: 10px 15px;
  background: rgba(14, 62, 108, 0.7);
  border-radius: 7px;
  color: white;
  max-width: 100%;
  line-height: 26px;
  white-space: pre-wrap;
  float: left;
  position: relative;
}

.amm2 {
  text-align: right;
  font-size: 18px;
  font-weight: bold;
  color: #516D9E;
  margin-bottom: 5px;
}

.amm6 {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  color: #516D9E;
  margin-bottom: 5px;
}

.amm4 {
  width: 60px;
  height: 60px;
  margin-left: 20px;
  border-radius: 50%;
}

.amm7 {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}

.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 27px;
}

.mlp2 {
  font-size: 11px;
}

</style>